import { loadRemoteModule } from '@angular-architects/module-federation';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from '../../../shared/services/authorization.service';
import { HeaderService } from '../../../shared/services/header.service';
import config from '../../../../assets/config.json';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
})
export class TermsAndConditionsComponent implements OnInit {
  token: string = '';
  isAuthorized: Boolean = false;
  @ViewChild('TermsAndConditionsComponent', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  @ViewChild('UnauthorizedComponent', { read: ViewContainerRef, static: true })
  unautorizecontainer!: ViewContainerRef;
  constructor(
    private _authservice: AuthorizationService,
    private _headerService: HeaderService,
  ) {
    this._authservice.getAccessToken().then((token) => {
      this.token = token;
    });
  }

  async ngOnInit() {
    const { TermsAndConditionsComponent } = await loadRemoteModule({
      type: 'module',
      remoteEntry: config.accessDelegationRemoteURL,
      exposedModule: './TermsAndConditionsComponent',
    });
    const componentFactory: any = this.container.createComponent(TermsAndConditionsComponent);
    componentFactory.instance.token = this.token;
    componentFactory.instance.roles = this._authservice.getFormattedGroups();
    this.container.insert(componentFactory.hostView);
  }
}
